import { connect } from 'react-redux';
import BuatDaftarBuku from '../../../views/Library/TableAsal/BuatDaftarBuku.library.view';
import { getStudent } from '../../../states/thunks/student.thunk';

function mapDispatchToProps(dispatch) {
  return {
    handleGetStudent: () => dispatch(getStudent()),
  };
}

export default connect(null, mapDispatchToProps)(BuatDaftarBuku);
